export function doesCookieExist(cookieName: string) {
  return document.cookie
    .split(";")
    .some((item) => item.trim().startsWith(`${cookieName}=`));
}

export function getCookie(cookieName: string) {
  return (
    document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${cookieName}=`))
      ?.split("=")[1] ?? null
  );
}

export function setCookie(
  cookieName: string,
  cookieValue: unknown,
  options?: string,
) {
  document.cookie = `${cookieName}=${cookieValue}${
    options === undefined ? "" : `; ${options}`
  }`;
}

export function deleteCookie(cookieName: string, options?: string) {
  document.cookie = `${cookieName}= ; Max-Age=0; Expires=${new Date(
    1970,
    0,
    1,
  ).toUTCString()}${options === undefined ? "" : `; ${options}`}`;
}
